export default __webpack_public_path__ + "static/media/sidebar_submissions_gray.8e2f2729.svg";